import { render } from "./CIS-Footer-Copyright.vue?vue&type=template&id=560d38ae"
import script from "./CIS-Footer-Copyright.vue?vue&type=script&lang=js"
export * from "./CIS-Footer-Copyright.vue?vue&type=script&lang=js"

import "./CIS-Footer-Copyright.vue?vue&type=style&index=0&id=560d38ae&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__